// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormInvoice } from '~/utils/interface/invoice';
import { EMPTY_STRING } from '~/utils/constants/common';
import { DiscountTypeEnum } from '~/utils/enum/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormInvoice> => {
  return yup.object().shape({
    orderId: yup.string().trim().optional(),
    clientId: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    paymentTerms: yup.string().trim().optional(),
    invoiceDate: yup.string().trim().optional(),
    dueDate: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    status: yup.string().trim().optional(),
    subtotal: yup.string().trim().optional(),
    taxRate: yup.string().trim().optional(),
    amountDue: yup.string().trim().optional(),
    taxAmount: yup.string().trim().optional(),
    total: yup.string().trim().optional(),
    amountPaid: yup.string().trim().optional(),
    balanceDue: yup.string().trim().optional(),
    note: yup.string().trim().optional(),
    discountRate: yup.string().trim().optional(),
    discountType: yup.string().trim().optional(),
    invoiceItems: yup
      .array(
        yup.object().shape({
          id: yup.string().trim().optional(),
          productId: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
          inventoryId: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
          idDetail: yup.string().trim().optional(),
          variantId: yup.string().trim().optional(),
          name: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
          variantName: yup.string().trim().optional(),
          quantity: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
          laborCost: yup.string().trim().optional(),
          type: yup.string().trim().optional(),
          price: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
          discountType: yup.string().trim().optional(),
          discountRate: yup.string().trim().optional(),
          total: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
        })
      )
      .optional(),
    deleteItemIds: yup.array().optional(),
  });
};

export const defaultValuesInvoiceForm: IFormInvoice = {
  orderId: EMPTY_STRING,
  clientId: EMPTY_STRING,
  paymentTerms: EMPTY_STRING,
  invoiceDate: EMPTY_STRING,
  dueDate: EMPTY_STRING,
  status: EMPTY_STRING,
  subtotal: EMPTY_STRING,
  taxRate: EMPTY_STRING,
  taxAmount: EMPTY_STRING,
  total: EMPTY_STRING,
  amountPaid: EMPTY_STRING,
  balanceDue: EMPTY_STRING,
  note: EMPTY_STRING,
  discountRate: EMPTY_STRING,
  discountType: EMPTY_STRING,
  invoiceItems: [
    {
      inventoryId: EMPTY_STRING,
      productId: EMPTY_STRING,
      variantId: EMPTY_STRING,
      name: EMPTY_STRING,
      variantName: EMPTY_STRING,
      quantity: EMPTY_STRING,
      laborCost: EMPTY_STRING,
      price: EMPTY_STRING,
      discountType: DiscountTypeEnum.AMOUNT,
      discountRate: EMPTY_STRING,
      total: EMPTY_STRING,
    },
  ],
};
